import { Routes } from '@angular/router';

export const projectRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./portfolio-page.component').then((m) => m.PortfolioPageComponent),
  },
  {
    path: 'project/:id',
    loadComponent: () => import('./project/project.component').then((m) => m.ProjectComponent),
  },
];
